// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ELiPx","fullView":"styles_fullView__LCS7k"};